import { Injectable, signal, computed } from "@angular/core";

@Injectable({ providedIn: "root" })
export class LoadingService {
  private navigating = signal(false);
  private pendingRequests = signal(0);
  private activeTasks = signal(0);

  /** True when a route navigation is in progress */
  readonly isNavigating = this.navigating.asReadonly();

  /** True when at least one HTTP request is pending */
  readonly isLoadingHttp = computed(() => this.pendingRequests() > 0);

  /** True when navigating, waiting for HTTP, or a manual task is active */
  readonly isLoading = computed(() => this.navigating() || this.pendingRequests() > 0 || this.activeTasks() > 0);

  setNavigating(value: boolean) {
    this.navigating.set(value);
  }

  incrementRequests() {
    this.pendingRequests.update((n) => n + 1);
  }

  decrementRequests() {
    this.pendingRequests.update((n) => Math.max(0, n - 1));
  }

  /** Start a long-running task (e.g. chunked upload) to keep loading bar visible */
  startTask() {
    this.activeTasks.update((n) => n + 1);
  }

  /** End a long-running task */
  endTask() {
    this.activeTasks.update((n) => Math.max(0, n - 1));
  }
}
